<template>
  <div class="truncated-list">
    <ul
      class="truncated-list__list"
      :class="{
        'desktop-table-col-3': desktopTableCol3,
        'desktop-table-col-2': desktopTableCol2,
        'no-gap': noGap,
      }"
    >
      <li
        v-for="(item, index) in displayedData"
        :key="item.uuid || item.id"
        class="truncated-list__list__item"
      >
        <slot
          :element="item"
          :index="index"
        >
          {{ item }}
        </slot>
      </li>
    </ul>
    <div
      v-if="isSeeMoreButtonDisplayed"
      class="expand-btn"
      :class="{ 'left': expandButtonLeft}"
    >
      <SplButton
        variant="link"
        @click="handleSeeMoreButton()"
      >
        <span v-if="expandButtonLabel">{{ expandButtonLabel }}</span>
        <Lang
          v-else
          by-key="see-more"
          capitalize-first
        />
      </SplButton>
    </div>
  </div>
</template>

<script lang="ts">
import SplButton from './form/SplButton.vue'

export default defineNuxtComponent({
  components: {
    SplButton
  },
  props: {
    data: {
      type: Array as PropType<any[]>,
      required: true,
    },
    splitAt: {
      type: Number,
      default: () => 3,
    },
    isSeeMoreButtonEnabled: {
      type: Boolean,
      default: () => true,
    },
    expandButtonLabel: {
      type: String,
      default: () => ''
    },
    expandButtonLeft: {
      type: Boolean,
      default: false,
    },
    desktopTableCol3: {
      type: Boolean,
      default: false,
    },
    desktopTableCol2: {
      type: Boolean,
      default: false,
    },
    noGap: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const splitAtState = ref<number>(props.splitAt)
    const handleSeeMoreButton = () => {
      emit('onSeeMoreClick')

      if (props.isSeeMoreButtonEnabled) {
        splitAtState.value = (splitAtState.value + props.splitAt)
      }
    }

    const displayedData = computed(() => props.data.slice(0, splitAtState.value))

    const isSeeMoreButtonDisplayed = computed(() => props.data.length > splitAtState.value)

    return {
      displayedData,
      splitAtState,
      handleSeeMoreButton,
      isSeeMoreButtonDisplayed,
    }
  },
})
</script>

<style lang="scss" scoped>
.expand-btn {
  @apply my-40p;
  @apply flex justify-center;
}

.left {
  @apply my-2;
  @apply justify-start;
}

.truncated-list {
  &__list {
    @apply flex flex-col;
    @apply gap-2;

    @apply mb-2;

    &__item {
      list-style-type: none;
      @apply mx-2 p-0;
      @apply h-auto;
      @screen lg {
        @apply m-0;
      }
    }
  }
}

.truncated-list__list.desktop-table-col-3 {
  @screen lg {
    @apply grid grid-cols-3;
    @apply gap-4;
  }
}

.truncated-list__list.desktop-table-col-2 {
  @screen lg {
    @apply grid grid-cols-2;
    @apply gap-4;
  }
}

.truncated-list__list.no-gap {
  @apply gap-0;
}
</style>
